import React from 'react';
import { useTelegramHandoff } from '../../hooks/useTelegramHandoff';
import { useTheme, useAssetUrl } from '../../lib/ThemeContext';
import { TelegramIcon } from '../TelegramIcon';

export const WelcomeScreen: React.FC = () => {
  const { telegramBotUrl, t } = useTheme();
  const assetUrl = useAssetUrl();
  const openTelegram = useTelegramHandoff(telegramBotUrl);

  return (
    <div
      className="wc-screen-fade-in"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '16px',
        paddingBottom: '90px',
        paddingRight: '12px',
        paddingTop: '80px',
        paddingLeft: '12px',
        flex: '1 0 0',
        width: '100%',
        minHeight: 0,
        zIndex: 2,
        overflow: 'hidden',
      }}
    >
      {/* Mascot */}
      <img
        src={assetUrl('/widget/nv-mascot.webp')}
        alt=""
        style={{
          width: '152px',
          height: 'auto',
          maxHeight: '241px',
          objectFit: 'contain',
          flexShrink: 1,
        }}
      />

      {/* Text */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          alignItems: 'center',
          textAlign: 'center',
          width: '100%',
        }}
      >
        <p
          style={{
            fontFamily: "'WC-Involve', sans-serif",
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: '28px',
            color: '#FE7338',
            margin: 0,
            width: '100%',
          }}
        >
          {t.welcomeScreen?.title || 'Добро пожаловать!'}
        </p>
        <p
          style={{
            fontFamily: "'WC-Involve', sans-serif",
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#2E2E2E',
            margin: 0,
            width: '100%',
          }}
        >
          {t.welcomeScreen?.subtitle || 'Напишите сообщение, чтобы начать диалог'}
        </p>
      </div>

      {/* Telegram section */}
      {telegramBotUrl && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <p
            style={{
              fontFamily: "'WC-Involve', sans-serif",
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '20px',
              color: 'rgba(46, 46, 46, 0.7)',
              textAlign: 'center',
              margin: 0,
            }}
          >
            {t.welcomeScreen?.telegramHint || 'Также доступен чат-бот Telegram'}
          </p>
          <a
            href={telegramBotUrl}
            onClick={openTelegram}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 8px 6px 16px',
              background: '#FFFFFF',
              border: '1px solid rgba(46, 46, 46, 0.15)',
              borderRadius: '100px',
              textDecoration: 'none',
              cursor: 'pointer',
            }}
          >
            <span
              style={{
                fontFamily: "'WC-Involve', sans-serif",
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                color: '#2E2E2E',
                whiteSpace: 'nowrap',
              }}
            >
              {t.welcomeScreen?.telegramButton || 'в Telegram'}
            </span>
            <TelegramIcon size={16} fill="#2E2E2E" />
          </a>
        </div>
      )}
    </div>
  );
};
